<template>
  <div class="settings-card">
    <div class="card-header">
      <h3><i class="fas fa-shopping-cart"></i> Cấu hình Bán hàng</h3>
    </div>
    <div class="card-body">
      <div class="settings-list">
        <div class="setting-item">
          <div class="setting-info">
            <label>Cho phép xuất kho âm</label>
            <p>Cho phép tạo đơn hàng khi số lượng tồn kho không đủ</p>
          </div>
          <van-switch v-model="localData.allowNegativeStock" @input="update" size="24px" />
        </div>

        <div class="setting-item">
          <div class="setting-info">
            <label>Cho phép bán nợ</label>
            <p>Cho phép khách hàng nợ tiền sau khi hoàn tất đơn hàng</p>
          </div>
          <van-switch v-model="localData.allowDebt" @input="update" size="24px" />
        </div>

        <div class="setting-item">
          <div class="setting-info">
            <label>Bắt buộc chọn khách hàng</label>
            <p>Yêu cầu phải có thông tin khách hàng mới được thanh toán</p>
          </div>
          <van-switch v-model="localData.requireCustomer" @input="update" size="24px" />
        </div>

        <div class="setting-item">
          <div class="setting-info">
            <label>Cho phép sửa giá bán</label>
            <p>Nhân viên có thể thay đổi đơn giá sản phẩm trong giỏ hàng</p>
          </div>
          <van-switch v-model="localData.allowEditPrice" @input="update" size="24px" />
        </div>

        <div class="form-group mb-3">
          <label>Kiểu giảm giá mặc định</label>
          <select v-model="localData.discountType" @change="update" class="form-control">
            <option value="percent">Phần trăm (%)</option>
            <option value="fixed">Số tiền mặt (đ)</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {
      localData: JSON.parse(JSON.stringify(this.data))
    }
  },
  watch: {
    data: {
      handler(val) {
        this.localData = JSON.parse(JSON.stringify(val));
      },
      deep: true
    }
  },
  methods: {
    update() {
      this.$emit('update', 'sales', this.localData);
    }
  }
}
</script>
